// extracted by mini-css-extract-plugin
export default {"text-area":"styles_text-area__LTfeW","text-area-inner":"styles_text-area-inner__PFIEe"};